/**
 * Application version — used by the fallback footer in Layout.jsx when the
 * authoritative `/api/system/about` endpoint has not yet responded.
 *
 * PO directive 2026-07-30 · Version 1.0.1 · Frontend no longer hardcodes
 * version metadata. This file exists only for a graceful fallback string
 * before the About endpoint has been fetched. The authoritative source is
 * `/api/system/about`, consumed via `useSystemAbout`.
 */
export const APP_VERSION = "1.2.1-rc";
export const COPYRIGHT_HOLDER = "Coolman Fuels Ltd.";

